import React, { useState } from 'react';
import CourseList from '../components/CourseList';
import PaymentModal from '../components/PaymentModal';
import SuccessModal from '../components/SuccessModal';
import PromotionalPosters from '../components/PromotionalPosters';
import Testimonials from '../components/Testimonials';
import { courses } from '../data/courses';
import './Home.css';

function Home() {
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [enrolledCourse, setEnrolledCourse] = useState(null);

  const handleEnroll = (course) => {
    setSelectedCourse(course);
    setShowPaymentModal(true);
  };

  const handleClosePaymentModal = () => {
    setShowPaymentModal(false);
    setSelectedCourse(null);
  };

  const handleConfirmPayment = (course, formData) => {
    setShowPaymentModal(false);
    setEnrolledCourse(course);
    setShowSuccessModal(true);
    // In a real application, you would send formData to a backend here
    console.log('Enrollment Data:', formData);
  };

  const handleCloseSuccessModal = () => {
    setShowSuccessModal(false);
    setEnrolledCourse(null);
    setSelectedCourse(null);
  };

  return (
    <div className="home">
      <div className="intro-section">
        <h2>Project-Based Learning Programs</h2>
        <p>
          Choose from our comprehensive project-based courses designed to give you 
          hands-on experience and industry-relevant skills. Complete the projects 
          and earn your certificate!
        </p>
      </div>
      
      <div className="banner-image-section">
        <div className="banner-svg">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 400" className="banner-image">
            <defs>
              <linearGradient id="grad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style={{ stopColor: '#667eea', stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: '#764ba2', stopOpacity: 1 }} />
              </linearGradient>
            </defs>
            <rect width="1200" height="400" fill="url(#grad)" />
            <text 
              x="50%" 
              y="45%" 
              fontSize="48" 
              fontWeight="bold" 
              fill="white" 
              textAnchor="middle"
            >
              Learn. Build. Succeed.
            </text>
            <text 
              x="50%" 
              y="60%" 
              fontSize="24" 
              fill="white" 
              textAnchor="middle" 
              opacity="0.9"
            >
              Hands-on Project-Based Learning
            </text>
          </svg>
        </div>
      </div>
      
      <PromotionalPosters />
      
      <CourseList courses={courses} onEnroll={handleEnroll} />
      
      <Testimonials />

      {showPaymentModal && (
        <PaymentModal
          course={selectedCourse}
          onClose={handleClosePaymentModal}
          onConfirm={handleConfirmPayment}
        />
      )}

      {showSuccessModal && (
        <SuccessModal
          course={enrolledCourse}
          onClose={handleCloseSuccessModal}
        />
      )}
    </div>
  );
}

export default Home;
